import { useState } from "react"
import axiosInstance from "../../../services/axios-client";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";

const useDetailCurrentProject = () => {
    const [calibratedUsers, setCalibratedUsers] = useState([])
    const [calibratedScore, setCalibratedScore] = useState({})
    const [scoreDistribution, setScoreDistribution] = useState({})
    const [actualScore, setActualScore] = useState({})
    const [projectPhase, setProjectPhase] = useState()
    const [projectRemark, setProjectRemark] = useState()
    const [project, setProject] = useState()
    const [canSubmit, setCanSubmit] = useState(false)
    const [waitForPreviousCalibration, setWaitForPreviousCalibration] = useState(false)
    const [averageAllScore, setAverage] = useState(0)
    const [ratingQuota, setRatingQuota] = useState({
        Latest: "",
        APlus: 0,
        A: 0,
        BPlus: 0,
        B: 0,
        C: 0,
        D: 0
    })
    const [totalTopUser, setTotalTopUser] = useState(0)
    const [justificationIdNotFilled, setJustificationNotFilled] = useState([])
    const [countCalibrated, setCountCalibrated] = useState({
        APlus: 0,
        A: 0,
        BPlus: 0,
        B: 0,
        C: 0,
        D: 0
    })
    const [deviationRating, setDeviationRating] = useState()
    const [ratingState, setRatingState] = useState({
        'A+': 6,
        'A': 5,
        'B+': 4,
        'B': 3,
        'C': 2,
        'D': 1
    })
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [phaseOption, setPhaseOption] = useState();
    const [alreadySendToManager, setAlreadySendToManager] = useState(false);
    const [canSendToManager, setCanSendToManager] = useState(false)
    const [sendBackCalibrations, setCanSendBackCalibrations] = useState(false);
    const [managerDeadline, setManagerDeadline] = useState();
    const [loadingPagestate, setLoadingPage] = useState(false)
    const [businessPerformance, setBusinessPerformance] = useState();
    const [userNameOption, setUserNameOption] = useState([{ 'label': 'ALL', 'value': 'all' }]);
    const [gradeOption, setGradeOption] = useState([{ 'label': 'ALL', 'value': 'all' }]);
    const [supervisorNameOption, setSupervisorNameOption] = useState([{ 'label': 'ALL', 'value': 'all' }]);
    const [divisionOption, setDivisionOption] = useState([{ 'label': 'ALL', 'value': 'all' }]);
    const [paramsData, setParamsData] = useState();
    const [currentUser, setCurrentUser] = useState();
    const [filteredCountCalibrated, setFilteredCountCalibrated] = useState({
        APlus: 0,
        A: 0,
        BPlus: 0,
        B: 0,
        C: 0,
        D: 0,
        Total: 0
    });
    const [filteredActualScore, setFilteredActualScore] = useState({
        APlus: 0,
        A: 0,
        BPlus: 0,
        B: 0,
        C: 0,
        D: 0,
        Total: 0
    });
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(1)
    const changePage = async (page, id, params, filterUserName, filterGrade, filterSupervisorName, filterDivision, sortName, sortGrade, sortActualScore, sortActualRating, sortCalibrationScore, sortCalibrationRating, filterCalibrationRating, phaseBefore, sortScoreBefore, sortRatingBefore, filterRatingBefore, filterChangeScore, filterActualRating, withAdditionalInfo) => {
        if (checkAllConditionThisPage()) {
            setPage(page)
            getUserCurrentProject(id, params.prev_calibrator, params.bu_performance, params.type, params.rating, params.project_id, page, filterUserName, filterGrade, filterSupervisorName, filterDivision, sortName, sortGrade, sortActualScore, sortActualRating, sortCalibrationScore, sortCalibrationRating, filterCalibrationRating, phaseBefore, sortScoreBefore, sortRatingBefore, filterRatingBefore, filterChangeScore, filterActualRating, withAdditionalInfo);
        }
    }

    const location = useLocation();
    const navigate = useNavigate()
    const onChangeHandler = async (e, calibrationScoreID, calibratorID, params) => {
        if (calibrationScoreID) {
            return onChangeRatingHelper(e, calibrationScoreID, calibratorID, params)
        }
    };

    // Check if excess or not
    const checkCalibratedExcessRatingQuota = (rating) => {
        if (!project[rating + "Excess"]) {
            if (countCalibrated[rating] + 1 > ratingQuota[rating]) {
                return false
            } else {
                return true
            }
        }
        return true
    }

    // automatically change score when changing rating
    const onChangeRatingHelper = async (newRating, userID, calibratorID, params) => {
        // Turn this on if want to use 2 level
        // if (Math.abs(ratingState[newRating]-ratingState[calibratedScore[userID].ActualRating]) > 2) {
        //     toast.error("Maximum rating change's is 2 level upper or below the actual rating")
        //     return "error"
        // }else{
        let newPayload = { ...calibratedScore };
        let rating = newRating.replace("+", "Plus")
        // let latest = calibratedScore[userID].CalibrationRating.replace("+", "Plus")
        if (!checkCalibratedExcessRatingQuota(rating)) {
            toast.error("You must follow the guidance to calibrate the score")
            // await postChangeRatingScore({
            //     EmployeeID: userID,
            //     ProjectPhaseID: newPayload[userID].ProjectPhaseID,
            //     ProjectID: newPayload[userID].ProjectID,
            //     CalibratorID : newPayload[userID].CalibratorID,
            //     CalibrationScore: newPayload[userID].CalibrationScore,
            //     CalibrationRating: newRating,
            //     JustificationType: justificationType,
            //     FilledTopBottomMark: justificationType === "default",
            // })
        } else {
            // Call API CHANGE SCORE
            let justificationType = checkTopBottomRemark(newPayload[userID].ActualRating, newRating)
            const response = await postChangeRatingScore({
                EmployeeID: userID,
                ProjectPhaseID: newPayload[userID].ProjectPhaseID,
                ProjectID: newPayload[userID].ProjectID,
                CalibratorID: newPayload[userID].CalibratorID,
                CalibrationScore: newPayload[userID].CalibrationScore,
                CalibrationRating: newRating,
                JustificationType: justificationType,
                FilledTopBottomMark: justificationType === "default",
            })
            getTotalCalibratedScore(calibratorID, params.prev_calibrator || "", params.bu_performance, params.type, params.project_id)
            newPayload[userID].CalibrationRating = newRating

            // Use API response data if available
            if (response?.data?.data) {
                newPayload[userID].JustificationType = response.data.data.JustificationType || justificationType
                newPayload[userID].FilledTopBottomMark = response.data.data.FilledTopBottomMark
            } else {
                // Fallback to original logic if no response
                newPayload[userID].JustificationType = justificationType
                newPayload[userID].FilledTopBottomMark = justificationType === "default"
            }            // updateRating(rating, latest, userID)
            setCalibratedScore(newPayload);
        }
        // }
    }

    const automaticallyChangeRating = async (e, calibratorID, params) => {
        let newPayload = { ...calibratedScore };
        let newValue = parseFloat(e.target.value);
        let id = e.target.name
        // let latest = calibratedScore[id].CalibrationRating.replace("+", "Plus")

        if (newValue < 0 && newValue > 5) {
            toast.error("Calibration should be between 0 and 5")
            return ""
        }

        let newRating = ""
        if (newValue >= scoreDistribution?.ScoreDistributions[0]?.APlusLowerLimit && newValue <= scoreDistribution?.ScoreDistributions[0]?.APlusUpperLimit) {
            if (!checkCalibratedExcessRatingQuota("APlus")) {
                toast.error("You must follow the guidance to calibrate the score")
                return ""
            }
            newRating = "A+";
        } else if (newValue >= scoreDistribution?.ScoreDistributions[0]?.ALowerLimit && newValue <= scoreDistribution?.ScoreDistributions[0]?.AUpperLimit) {
            if (!checkCalibratedExcessRatingQuota("A")) {
                toast.error("You must follow the guidance to calibrate the score")
                return ""
            }
            newRating = "A";
        } else if (newValue >= scoreDistribution?.ScoreDistributions[0]?.BPlusLowerLimit && newValue <= scoreDistribution?.ScoreDistributions[0]?.BPlusUpperLimit) {
            if (!checkCalibratedExcessRatingQuota("BPlus")) {
                toast.error("You must follow the guidance to calibrate the score")
                return ""
            }
            newRating = "B+";
        } else if (newValue >= scoreDistribution?.ScoreDistributions[0]?.BLowerLimit && newValue <= scoreDistribution?.ScoreDistributions[0]?.BUpperLimit) {
            if (!checkCalibratedExcessRatingQuota("B")) {
                toast.error("You must follow the guidance to calibrate the score")
                return ""
            }
            newRating = "B";
        } else if (newValue >= scoreDistribution?.ScoreDistributions[0]?.CLowerLimit && newValue <= scoreDistribution?.ScoreDistributions[0]?.CUpperLimit) {
            if (!checkCalibratedExcessRatingQuota("C")) {
                toast.error("You must follow the guidance to calibrate the score")
                return ""
            }
            newRating = "C";
        } else {
            if (!checkCalibratedExcessRatingQuota("D")) {
                toast.error("You must follow the guidance to calibrate the score")
                return ""
            }
            newRating = "D";
        }
        let justificationType = checkTopBottomRemark(newPayload[id].ActualRating, newRating)
        let valueFilled = justificationType === "default"
        if (newPayload[id].CalibrationRating === newRating) {
            valueFilled = newPayload[id].FilledTopBottomMark
        }
        newPayload[id].CalibrationScore = newValue
        newPayload[id].CalibrationRating = newRating
        newPayload[id].JustificationType = justificationType
        newPayload[id].FilledTopBottomMark = valueFilled
        setCalibratedScore(newPayload);

        // }
    };

    const getUserCurrentProject = async (calibratorId, prevCalibrator, businessUnit, type, rating, projectID, page,
        filterEmployee = [], filterGrade = [], filterSupervisorName = [], filterDivision = [], sortName = "default", sortGrade = "default",
        sortActualScore = "default", sortActualRating = "default",
        sortCalibrationScore = "default", sortCalibrationRating = "default", filterCalibrationRating = "",
        calibrationPhaseBefore = -1, orderCalibrationScoreBefore = "default", orderCalibrationRatingBefore = "default", filterCalibrationRatingBefore = "", filterChangeScore = "all", filterActualRating = "", withAdditionalInfo = "", projectPhaseOrder = null) => {
        try {
            setLoadingPage(true)
            let calibratedScores = {}
            let employeeNames = filterEmployee.join(';')
            let grades = filterGrade.join(';')
            let supervisorNames = filterSupervisorName.join(';')
            let divisions = filterDivision.join(';')
            let ratingChangedStatus = "all"
            let ratingChanged = 0

            if (typeof filterChangeScore === 'string') {
                ratingChangedStatus = filterChangeScore
            } else {
                ratingChanged = filterChangeScore
            }

            const resolvedProjectPhaseOrder = projectPhaseOrder ?? new URLSearchParams(location.search).get("projectPhaseOrder")
            let api; // Declare the 'api' variable
            if (type === "n-1") {
                const projectPhaseOrderParam = resolvedProjectPhaseOrder ? `&projectPhaseOrder=${encodeURIComponent(resolvedProjectPhaseOrder)}` : ""
                api = `/auth/projects/calibrations-n-minus-one?calibratorID=${calibratorId}&businessUnit=${businessUnit}&projectID=${projectID}&page=${page}&limit=${100}&employeeNames=${encodeURIComponent(employeeNames)}&grades=${encodeURIComponent(grades)}&supervisorNames=${encodeURIComponent(supervisorNames)}&division=${encodeURIComponent(divisions)}&orderEmployeeName=${sortName}&orderGrade=${sortGrade}&orderActualScore=${sortActualScore}&orderActualRating=${sortActualRating}&orderCalibrationScore=${sortCalibrationScore}&orderCalibrationRating=${sortCalibrationRating}&filterCalibrationRating=${encodeURIComponent(filterCalibrationRating)}&calibrationPhaseBefore=${calibrationPhaseBefore}&orderCalibrationScoreBefore=${orderCalibrationScoreBefore}&orderCalibrationRatingBefore=${orderCalibrationRatingBefore}&filterCalibrationRatingBefore=${encodeURIComponent(filterCalibrationRatingBefore)}&ratingChangedStatus=${ratingChangedStatus}&ratingChanged=${ratingChanged}&filterActualRating=${encodeURIComponent(filterActualRating)}&withAdditionalInfo=${encodeURIComponent(withAdditionalInfo)}${projectPhaseOrderParam}`;
            } else if (type === "numberOne") {
                api = `/auth/projects/calibrations-one?calibratorID=${calibratorId}&businessUnit=${businessUnit}&prevCalibrator=${prevCalibrator}&projectID=${projectID}&division=${encodeURIComponent(divisions)}`;
            } else if (type === "default") {
                const projectPhaseOrderParam = resolvedProjectPhaseOrder ? `&projectPhaseOrder=${encodeURIComponent(resolvedProjectPhaseOrder)}` : ""
                api = `/auth/projects/calibrations?calibratorID=${calibratorId}&businessUnit=${businessUnit}&prevCalibrator=${prevCalibrator || ""}&projectID=${projectID}&page=${page}&limit=${100}&employeeNames=${encodeURIComponent(employeeNames)}&grades=${encodeURIComponent(grades)}&supervisorNames=${encodeURIComponent(supervisorNames)}&division=${encodeURIComponent(divisions)}&orderEmployeeName=${sortName}&orderGrade=${sortGrade}&orderActualScore=${sortActualScore}&orderActualRating=${sortActualRating}&orderCalibrationScore=${sortCalibrationScore}&orderCalibrationRating=${sortCalibrationRating}&filterCalibrationRating=${encodeURIComponent(filterCalibrationRating)}&calibrationPhaseBefore=${calibrationPhaseBefore}&orderCalibrationScoreBefore=${orderCalibrationScoreBefore}&orderCalibrationRatingBefore=${orderCalibrationRatingBefore}&filterCalibrationRatingBefore=${encodeURIComponent(filterCalibrationRatingBefore)}&ratingChangedStatus=${ratingChangedStatus}&ratingChanged=${ratingChanged}&filterActualRating=${encodeURIComponent(filterActualRating)}&withAdditionalInfo=${encodeURIComponent(withAdditionalInfo)}${projectPhaseOrderParam}`;
            } else if (type === "all" && businessUnit && businessUnit !== "all") {
                // For type="all" with specific BU, make two API calls and consolidate
                // First API call - get all users with filters
                const projectPhaseOrderParam = resolvedProjectPhaseOrder ? `&projectPhaseOrder=${encodeURIComponent(resolvedProjectPhaseOrder)}` : ""
                api = `/auth/projects/calibrations-all-bu?calibratorID=${calibratorId}&businessUnit=${businessUnit}&projectID=${projectID}&page=${page}&limit=${100}&employeeNames=${encodeURIComponent(employeeNames)}&grades=${encodeURIComponent(grades)}&supervisorNames=${encodeURIComponent(supervisorNames)}&division=${encodeURIComponent(divisions)}&orderEmployeeName=${sortName}&orderGrade=${sortGrade}&orderActualScore=${sortActualScore}&orderActualRating=${sortActualRating}&orderCalibrationScore=${sortCalibrationScore}&orderCalibrationRating=${sortCalibrationRating}&filterCalibrationRating=${encodeURIComponent(filterCalibrationRating)}&calibrationPhaseBefore=${calibrationPhaseBefore}&orderCalibrationScoreBefore=${orderCalibrationScoreBefore}&orderCalibrationRatingBefore=${orderCalibrationRatingBefore}&filterCalibrationRatingBefore=${encodeURIComponent(filterCalibrationRatingBefore)}&ratingChangedStatus=${ratingChangedStatus}&ratingChanged=${ratingChanged}&filterActualRating=${encodeURIComponent(filterActualRating)}&withAdditionalInfo=${encodeURIComponent(withAdditionalInfo)}${projectPhaseOrderParam}`;
            } else {
                // For other cases or multiple BUs, use all-bu endpoint
                const projectPhaseOrderParam = resolvedProjectPhaseOrder ? `&projectPhaseOrder=${encodeURIComponent(resolvedProjectPhaseOrder)}` : ""
                api = `/auth/projects/calibrations-all-bu?calibratorID=${calibratorId}&businessUnit=${businessUnit}&projectID=${projectID}&page=${page}&limit=${100}&employeeNames=${encodeURIComponent(employeeNames)}&grades=${encodeURIComponent(grades)}&supervisorNames=${encodeURIComponent(supervisorNames)}&division=${encodeURIComponent(divisions)}&orderEmployeeName=${sortName}&orderGrade=${sortGrade}&orderActualScore=${sortActualScore}&orderActualRating=${sortActualRating}&orderCalibrationScore=${sortCalibrationScore}&orderCalibrationRating=${sortCalibrationRating}&filterCalibrationRating=${encodeURIComponent(filterCalibrationRating)}&calibrationPhaseBefore=${calibrationPhaseBefore}&orderCalibrationScoreBefore=${orderCalibrationScoreBefore}&orderCalibrationRatingBefore=${orderCalibrationRatingBefore}&filterCalibrationRatingBefore=${encodeURIComponent(filterCalibrationRatingBefore)}&ratingChangedStatus=${ratingChangedStatus}&ratingChanged=${ratingChanged}&filterActualRating=${encodeURIComponent(filterActualRating)}&withAdditionalInfo=${encodeURIComponent(withAdditionalInfo)}${projectPhaseOrderParam}`;
            }

            if (rating) {
                if (prevCalibrator && prevCalibrator !== "N-1") {
                    api = `/auth/projects/calibrations-score?calibratorID=${encodeURIComponent(calibratorId)}&businessUnit=${businessUnit}&prevCalibrator=${prevCalibrator}&projectID=${projectID}&rating=${encodeURIComponent(rating)}&page=${page}&limit=${100}`;
                } else {
                    if (businessUnit) {
                        api = `/auth/projects/calibrations-score-all-bu?calibratorID=${encodeURIComponent(calibratorId)}&businessUnit=${businessUnit}&projectID=${projectID}&rating=${encodeURIComponent(rating)}&page=${page}&limit=${100}`
                    } else {
                        api = `/auth/projects/calibrations-score-all?calibratorID=${encodeURIComponent(calibratorId)}&projectID=${projectID}&rating=${encodeURIComponent(rating)}&page=${page}&limit=${100}`
                    }
                }
            }

            // Make the first API call
            let res = await axiosInstance.get(api)

            // For type="all" with specific BU, make second API call to get unjustified users
            let unjustifiedUsers = [];
            if (type === "all" && businessUnit && businessUnit !== "all" && !rating) {
                try {
                    const unjustifiedApi = `/auth/projects/calibrations-unjustified?calibratorID=${calibratorId}&businessUnit=${businessUnit}&projectID=${projectID}`;
                    const unjustifiedRes = await axiosInstance.get(unjustifiedApi);

                    if (unjustifiedRes.status === 200 && unjustifiedRes.data.data?.[0]?.UserData) {
                        unjustifiedUsers = unjustifiedRes.data.data[0].UserData;
                    }
                } catch (unjustifiedError) {
                    console.error('   Error details:', unjustifiedError.response?.data || unjustifiedError.message);
                    // Continue with main flow even if unjustified call fails
                }
            }

            if (res.status === 200) {
                setJustificationNotFilled([])
                setCanSendToManager((prev) => (prev || res.data.data[0].NPlusOneManager))
                setAlreadySendToManager((prev) => (prev || (res.data.data[0].SendToManager)))
                setCanSendBackCalibrations((prev) => (prev || (res.data.data[0].SendBackCalibration)))
                let currentUser = res.data.data[0].UserData
                setTotalTopUser(0)
                setTotalPage(res.data.paging.TotalPages)

                if (currentUser) {
                    // let allName = [];
                    // let grade = [];
                    // let supervisorName = [];
                    for (let user of currentUser) {
                        // allName.push({
                        //     label: user.Name,
                        //     value: user.Name
                        // })
                        // grade.push({
                        //     label: user.Grade,
                        //     value: user.Grade
                        // })
                        // supervisorName.push({
                        //     label: user.SupervisorNames,
                        //     value: user.SupervisorNames
                        // })
                        let userCalScorelength = user.CalibrationScores.length
                        // let rating = ""
                        // rating = user.CalibrationScores[userCalScorelength - 1].CalibrationRating.replace("+", "Plus")
                        calibratedScores[user.ID] = {
                            ScoringMethod: user.ScoringMethod,
                            ProjectID: user.CalibrationScores[userCalScorelength - 1].ProjectID,
                            CalibratorID: user.CalibrationScores[userCalScorelength - 1].CalibratorID,
                            EmployeeID: user.ID,
                            ProjectPhaseID: user.CalibrationScores[userCalScorelength - 1].ProjectPhaseID,
                            CalibrationRating: user.CalibrationScores[userCalScorelength - 1].CalibrationRating,
                            CalibrationRatingBefore: user.CalibrationScores[userCalScorelength - 1].CalibrationRating,
                            CurrentSavedRating: user.CalibrationScores[userCalScorelength - 1].CalibrationRating,
                            CalibrationScore: (user.CalibrationScores[userCalScorelength - 1].CalibrationScore),
                            JustificationType: user.CalibrationScores[userCalScorelength - 1].JustificationType,
                            FilledTopBottomMark: user.CalibrationScores[userCalScorelength - 1].FilledTopBottomMark,
                            SpmoID: user.CalibrationScores[userCalScorelength - 1].SpmoID,
                            Status: user.CalibrationScores[userCalScorelength - 1].Status,
                            SpmoStatus: user.CalibrationScores[userCalScorelength - 1].SpmoStatus,
                            Comment: user.CalibrationScores[userCalScorelength - 1].Comment,
                            CalibrationRatingSaved: user.CalibrationScores[userCalScorelength - 1].CalibrationRating,
                            CalibrationScoreSaved: user.CalibrationScores[userCalScorelength - 1].CalibrationScore,
                            ActualScore: user.ActualScores[0].ActualScore,
                            ActualRating: user.ActualScores[0].ActualRating,
                        }
                        // if (userCalScorelength > 1) {     
                        //     if (user.CalibrationScores[userCalScorelength - 1].CalibrationRating!="") {
                        //         rating = user.CalibrationScores[userCalScorelength - 1].CalibrationRating.replace("+","Plus")
                        //         calibratedScores[user.ID] = {
                        //             ScoringMethod: user.ScoringMethod,
                        //             ProjectID: user.CalibrationScores[userCalScorelength - 1].ProjectID,
                        //             CalibratorID: user.CalibrationScores[userCalScorelength - 1].CalibratorID,
                        //             EmployeeID: user.ID,
                        //             ProjectPhaseID: user.CalibrationScores[userCalScorelength - 1].ProjectPhaseID,
                        //             CalibrationRating: user.CalibrationScores[userCalScorelength - 1].CalibrationRating,
                        //             CalibrationRatingBefore: user.ActualScores[0].ActualRating,
                        //             // CalibrationRatingBefore: user.CalibrationScores[userCalScorelength - 2].CalibrationRating,
                        //             CurrentSavedRating: user.CalibrationScores[userCalScorelength - 1].CalibrationRating,
                        //             CalibrationScore: (user.CalibrationScores[userCalScorelength - 1].CalibrationScore),
                        //             JustificationType:user.CalibrationScores[userCalScorelength - 1].JustificationType,
                        //             FilledTopBottomMark: false,
                        //             SpmoID: user.CalibrationScores[userCalScorelength - 1].SpmoID,
                        //             Status: user.CalibrationScores[userCalScorelength - 1].Status,
                        //             SpmoStatus: user.CalibrationScores[userCalScorelength - 1].SpmoStatus,
                        //             Comment: user.CalibrationScores[userCalScorelength - 1].Comment,
                        //         }
                        //     } else if (user.CalibrationScores[userCalScorelength - 2].CalibrationRating!=""){
                        //         rating = user.CalibrationScores[userCalScorelength - 2].CalibrationRating.replace("+","Plus")
                        //         calibratedScores[user.ID] = {
                        //             ScoringMethod: user.ScoringMethod,
                        //             ProjectID: user.CalibrationScores[userCalScorelength - 1].ProjectID,
                        //             CalibratorID: user.CalibrationScores[userCalScorelength - 1].CalibratorID,
                        //             EmployeeID: user.ID,
                        //             ProjectPhaseID: user.CalibrationScores[userCalScorelength - 1].ProjectPhaseID,
                        //             CalibrationRating: user.CalibrationScores[userCalScorelength - 2].CalibrationRating,
                        //             CalibrationRatingBefore: user.ActualScores[0].ActualRating,
                        //             CurrentSavedRating: user.CalibrationScores[userCalScorelength - 2].CalibrationRating,
                        //             // CalibrationRatingBefore: user.CalibrationScores[userCalScorelength - 2].CalibrationRating,
                        //             CalibrationScore: (user.CalibrationScores[userCalScorelength - 2].CalibrationScore),
                        //             JustificationType:user.CalibrationScores[userCalScorelength - 1].JustificationType,
                        //             FilledTopBottomMark: false,
                        //             SpmoID: user.CalibrationScores[userCalScorelength - 1].SpmoID,
                        //             Status: user.CalibrationScores[userCalScorelength - 1].Status,
                        //             SpmoStatus: user.CalibrationScores[userCalScorelength - 1].SpmoStatus,
                        //             Comment: user.CalibrationScores[userCalScorelength - 1].Comment,
                        //         }
                        //     } else{
                        //         rating = user.ActualScores[0].ActualRating.replace("+","Plus")
                        //         calibratedScores[user.ID] = {
                        //             ScoringMethod: user.ScoringMethod,
                        //             ProjectID: user.CalibrationScores[userCalScorelength - 1].ProjectID,
                        //             CalibratorID: user.CalibrationScores[userCalScorelength - 1].CalibratorID,
                        //             EmployeeID: user.ID,
                        //             ProjectPhaseID: user.CalibrationScores[userCalScorelength - 1].ProjectPhaseID,
                        //             CalibrationRating: user.ActualScores[0].ActualRating,
                        //             CalibrationRatingBefore: user.ActualScores[0].ActualRating,
                        //             CurrentSavedRating: user.ActualScores[0].ActualRating,
                        //             CalibrationScore: (user.ActualScores[0].ActualScore),
                        //             JustificationType:user.CalibrationScores[userCalScorelength - 1].JustificationType,
                        //             FilledTopBottomMark: false,
                        //             SpmoID: user.CalibrationScores[userCalScorelength - 1].SpmoID,
                        //             Status: user.CalibrationScores[userCalScorelength - 1].Status,
                        //             SpmoStatus: user.CalibrationScores[userCalScorelength - 1].SpmoStatus,
                        //             Comment: user.CalibrationScores[userCalScorelength - 1].Comment,
                        //         }
                        //     }
                        // } else{
                        //     if (user.CalibrationScores[userCalScorelength - 1].CalibrationRating!="") {
                        //         rating = user.CalibrationScores[userCalScorelength - 1].CalibrationRating.replace("+","Plus")
                        //         calibratedScores[user.ID] = {
                        //             ScoringMethod: user.ScoringMethod,
                        //             ProjectID: user.CalibrationScores[userCalScorelength - 1].ProjectID,
                        //             CalibratorID: user.CalibrationScores[userCalScorelength - 1].CalibratorID,
                        //             EmployeeID: user.ID,
                        //             ProjectPhaseID: user.CalibrationScores[userCalScorelength - 1].ProjectPhaseID,
                        //             CalibrationRating: user.CalibrationScores[userCalScorelength - 1].CalibrationRating,
                        //             CalibrationRatingBefore: user.ActualScores[0].ActualRating,
                        //             CurrentSavedRating: user.CalibrationScores[userCalScorelength - 1].CalibrationRating,
                        //             CalibrationScore: (user.CalibrationScores[userCalScorelength - 1].CalibrationScore),
                        //             JustificationType:user.CalibrationScores[userCalScorelength - 1].JustificationType,
                        //             FilledTopBottomMark: false,
                        //             SpmoID: user.CalibrationScores[userCalScorelength - 1].SpmoID,
                        //             Status: user.CalibrationScores[userCalScorelength - 1].Status,
                        //             SpmoStatus: user.CalibrationScores[userCalScorelength - 1].SpmoStatus,
                        //             Comment: user.CalibrationScores[userCalScorelength - 1].Comment,
                        //         }
                        //     } 
                        //     else {
                        //         rating = user.ActualScores[0].ActualRating.replace("+","Plus")
                        //         calibratedScores[user.ID] = {
                        //             ScoringMethod: user.ScoringMethod,
                        //             ProjectID: user.CalibrationScores[userCalScorelength - 1].ProjectID,
                        //             CalibratorID: user.CalibrationScores[userCalScorelength - 1].CalibratorID,
                        //             EmployeeID: user.ID,
                        //             ProjectPhaseID: user.CalibrationScores[userCalScorelength - 1].ProjectPhaseID,
                        //             CalibrationRating: user.ActualScores[0].ActualRating,
                        //             CalibrationRatingBefore: user.ActualScores[0].ActualRating,
                        //             CurrentSavedRating: user.ActualScores[0].ActualRating,
                        //             CalibrationScore: (user.ActualScores[0].ActualScore),
                        //             JustificationType:user.CalibrationScores[userCalScorelength - 1].JustificationType,
                        //             FilledTopBottomMark: false,
                        //             SpmoID: user.CalibrationScores[userCalScorelength - 1].SpmoID,
                        //             Status: user.CalibrationScores[userCalScorelength - 1].Status,
                        //             SpmoStatus: user.CalibrationScores[userCalScorelength - 1].SpmoStatus,
                        //             Comment: user.CalibrationScores[userCalScorelength - 1].Comment,
                        //         }
                        //     }
                        // }

                        // if(user.CalibrationScores[userCalScorelength - 1].Comment=="") {
                        //     calibratedScores[user.ID].Comment = user.CalibrationScores[0].Comment
                        // }

                        // if(userCalScorelength >= 2 && user.CalibrationScores[userCalScorelength-2].Comment!=""){
                        //     calibratedScores[user.ID].Comment = user.CalibrationScores[userCalScorelength-2].Comment
                        // }

                        if (
                            (user.CalibrationScores[userCalScorelength - 1].Status === "Calibrate" && user.CalibrationScores[userCalScorelength - 1].SpmoStatus === "-") ||
                            (user.CalibrationScores[userCalScorelength - 1].Status === "Complete" && user.CalibrationScores[userCalScorelength - 1].SpmoStatus === "Rejected") ||
                            (user.CalibrationScores[userCalScorelength - 1].Status === "Calibrate" && user.CalibrationScores[userCalScorelength - 1].SpmoStatus === "Rejected")
                            // || 
                            // (user.CalibrationScores[userCalScorelength-1].Status === "Calibrate" && user.CalibrationScores[userCalScorelength-1].SpmoStatus === "Accepted") || 
                            // (user.CalibrationScores[userCalScorelength-1].Status === "Complete" && user.CalibrationScores[userCalScorelength-1].SpmoStatus === "Accepted") ||
                            // (user.CalibrationScores[userCalScorelength-1].Status === "Complete" && user.CalibrationScores[userCalScorelength-1].SpmoStatus === "-")
                        ) {
                            setCanSubmit((prevState) => (prevState || true))
                        } else {
                            setCanSubmit((prevState) => (prevState || false))
                        }

                        if (user.CalibrationScores[userCalScorelength - 1].Status === "Waiting"
                            && user.CalibrationScores[userCalScorelength - 1].SpmoStatus === "-") {
                            setWaitForPreviousCalibration(waitForPreviousCalibration || true)
                        }

                        // if (
                        //     user.CalibrationScores[userCalScorelength - 1].BottomRemark.EmployeeID != "" || 
                        //     user.CalibrationScores[userCalScorelength - 1].TopRemarks.length != 0 || 
                        //     user.CalibrationScores[userCalScorelength - 1].JustificationType === "default"
                        // ) {
                        //     calibratedScores[user.ID].FilledTopBottomMark = true
                        // }else{
                        //     calibratedScores[user.ID].FilledTopBottomMark = false
                        // }
                        // caliCount[rating] += 1

                        let result_list = [];
                        let current_order = 1
                        user.CalibrationScores.forEach(item => {
                            let order = item.ProjectPhase.Phase.Order;
                            while (current_order < order) {
                                result_list.push({
                                    CalibrationRating: "",
                                    CalibrationScore: 0,
                                });
                                current_order++;
                            }
                            result_list.push(item);
                            current_order++;
                        });


                        if (user.CalibrationScores.length === 1) {
                            result_list[result_list.length - 1] = { ...result_list[result_list.length - 1], TopUser: true }
                            setTotalTopUser((prev) => (prev + 1))
                        }

                        user.CalibrationScores = result_list
                    }
                    // allName.sort((a, b) => a.value.localeCompare(b.value));
                    // grade = Array.from(new Set(grade.map(obj => JSON.stringify(obj)))).map(str => JSON.parse(str));
                    // grade.sort((a, b) => a.value.localeCompare(b.value));
                    // supervisorName = Array.from(new Set(supervisorName.map(obj => JSON.stringify(obj)))).map(str => JSON.parse(str));
                    // supervisorName.sort((a, b) => a.value.localeCompare(b.value));
                    // setSupervisorNameOption((prev) => [
                    //     ...new Set([...prev, ...allName])
                    // ]);

                    // setGradeOption((prev) => [
                    //     ...new Set([...prev, ...grade])
                    // ]);

                    // setSupervisorNameOption((prev) => [
                    //     ...new Set([...prev, ...supervisorName])
                    // ]);
                    // allUser.push(...res.data.data.UserData)

                    // Consolidate users: put unjustified users first, then regular users
                    let allUsers = [...res.data.data[0].UserData];
                    if (type === "all" && businessUnit && businessUnit !== "all" && unjustifiedUsers.length > 0) {
                        // Create a map of existing users from first API for quick lookup
                        const existingUserIds = new Set(allUsers.map(u => u.ID));

                        // Get IDs of unjustified users from second API
                        const unjustifiedUserIds = new Set(unjustifiedUsers.map(u => u.ID));

                        // Filter and process any unjustified users that are not already in allUsers (avoid duplicates)
                        const additionalUnjustifiedUsers = unjustifiedUsers
                            .filter(user => !existingUserIds.has(user.ID))
                            .map(user => {
                                // Process additional users to match the structure from first API
                                let userCalScorelength = user.CalibrationScores?.length || 0;

                                if (userCalScorelength > 0) {
                                    // Add to calibratedScores
                                    calibratedScores[user.ID] = {
                                        ScoringMethod: user.ScoringMethod,
                                        ProjectID: user.CalibrationScores[userCalScorelength - 1].ProjectID,
                                        CalibratorID: user.CalibrationScores[userCalScorelength - 1].CalibratorID,
                                        EmployeeID: user.ID,
                                        ProjectPhaseID: user.CalibrationScores[userCalScorelength - 1].ProjectPhaseID,
                                        CalibrationRating: user.CalibrationScores[userCalScorelength - 1].CalibrationRating,
                                        CalibrationRatingBefore: user.CalibrationScores[userCalScorelength - 1].CalibrationRating,
                                        CurrentSavedRating: user.CalibrationScores[userCalScorelength - 1].CalibrationRating,
                                        CalibrationScore: (user.CalibrationScores[userCalScorelength - 1].CalibrationScore),
                                        JustificationType: user.CalibrationScores[userCalScorelength - 1].JustificationType,
                                        FilledTopBottomMark: user.CalibrationScores[userCalScorelength - 1].FilledTopBottomMark,
                                        SpmoID: user.CalibrationScores[userCalScorelength - 1].SpmoID,
                                        Status: user.CalibrationScores[userCalScorelength - 1].Status,
                                        SpmoStatus: user.CalibrationScores[userCalScorelength - 1].SpmoStatus,
                                        Comment: user.CalibrationScores[userCalScorelength - 1].Comment,
                                        CalibrationRatingSaved: user.CalibrationScores[userCalScorelength - 1].CalibrationRating,
                                        CalibrationScoreSaved: user.CalibrationScores[userCalScorelength - 1].CalibrationScore,
                                        ActualScore: user.ActualScores?.[0]?.ActualScore || 0,
                                        ActualRating: user.ActualScores?.[0]?.ActualRating || "",
                                    };

                                    // Process CalibrationScores to match structure
                                    let result_list = [];
                                    let current_order = 1;
                                    user.CalibrationScores.forEach(item => {
                                        let order = item.ProjectPhase?.Phase?.Order || current_order;
                                        while (current_order < order) {
                                            result_list.push({
                                                CalibrationRating: "",
                                                CalibrationScore: 0,
                                            });
                                            current_order++;
                                        }
                                        result_list.push(item);
                                        current_order++;
                                    });

                                    if (user.CalibrationScores.length === 1) {
                                        result_list[result_list.length - 1] = { ...result_list[result_list.length - 1], TopUser: true };
                                        setTotalTopUser((prev) => (prev + 1));
                                    }

                                    user.CalibrationScores = result_list;
                                }

                                return user;
                            });

                        // Separate existing users into unjustified and justified
                        const usersNeedingJustification = allUsers.filter(user => unjustifiedUserIds.has(user.ID));
                        const usersWithJustification = allUsers.filter(user => !unjustifiedUserIds.has(user.ID));

                        // Consolidate: unjustified users first (from both APIs), then justified users
                        // This ensures no duplicates and unjustified users are at the top
                        allUsers = [...usersNeedingJustification, ...additionalUnjustifiedUsers, ...usersWithJustification];
                    }

                    setCalibratedUsers((prev) => (allUsers))
                    setCalibratedScore((prev) => ({ ...calibratedScores }));

                    // Handle justification priority sorting for submission pages
                    if (sortName === "justification_priority" && prevCalibrator) {
                        setTimeout(() => {
                            // Apply justification-based sorting after state updates
                            sortUsersByJustificationStatus();
                        }, 100);
                    }

                    // Handle consolidate justification mode - brings all users needing justification to current page
                    if (sortName === "consolidate_justification" && prevCalibrator) {
                        setTimeout(() => {
                            // Apply cross-page justification consolidation after state updates
                            sortUsersByJustificationStatus();
                        }, 100);
                    }
                    // setCountCalibrated((prev) => ({
                    //     ...prev,
                    //     Latest: caliCount.Latest || prev.Latest, // Update if provided
                    //     LatestID: caliCount.LatestID || prev.LatestID, // Update if provided
                    //     APlus: prev.APlus + (caliCount.APlus || 0),
                    //     A: prev.A + (caliCount.A || 0),
                    //     BPlus: prev.BPlus + (caliCount.BPlus || 0),
                    //     B: prev.B + (caliCount.B || 0),
                    //     C: prev.C + (caliCount.C || 0),
                    //     D: prev.D + (caliCount.D || 0),
                    // }));
                    page += 1;
                } else {
                    setCalibratedUsers([])
                    setCountCalibrated({})
                    setCalibratedScore({})
                }
            }
            // }
            // setCountCalibrated(caliCount)
            // setCalibratedScore(calibratedScores)
            // setCalibratedUsers(allUser)
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const getAllEmployeeName = async (calibratorId, prevCalibrator, businessUnit, type, projectID) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get(`/auth/projects/employee-name-filter?calibratorID=${calibratorId}&prevCalibrator=${prevCalibrator}&businessUnit=${businessUnit}&type=${type}&projectID=${projectID}`)
            if (res.status === 200) {
                let allName = []
                res.data.data.forEach(element => {
                    allName.push({
                        label: element,
                        value: element
                    })
                });
                setUserNameOption((prev) => [
                    ...new Set([...allName])
                ]);
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }

    }

    const getAllSupervisorName = async (calibratorId, prevCalibrator, businessUnit, type, projectID) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get(`/auth/projects/supervisor-name-filter?calibratorID=${calibratorId}&prevCalibrator=${prevCalibrator}&businessUnit=${businessUnit}&type=${type}&projectID=${projectID}`)
            if (res.status === 200) {
                let allName = []
                res.data.data.forEach(element => {
                    allName.push({
                        label: element,
                        value: element
                    })
                });
                setSupervisorNameOption((prev) => [
                    ...new Set([...allName])
                ]);
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }

    }
    const getAllGrade = async (calibratorId, prevCalibrator, businessUnit, type, projectID) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get(`/auth/projects/grade-filter?calibratorID=${calibratorId}&prevCalibrator=${prevCalibrator}&businessUnit=${businessUnit}&type=${type}&projectID=${projectID}`)
            if (res.status === 200) {
                let allName = []
                res.data.data.forEach(element => {
                    allName.push({
                        label: element,
                        value: element
                    })
                });
                setGradeOption((prev) => [
                    ...new Set([...allName])
                ]);
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }

    }

    const getAllDivision = async (calibratorId, prevCalibrator, businessUnit, type, projectID) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get(`/auth/projects/division?projectID=${projectID}&businessUnit=${businessUnit}`)
            if (res.status === 200) {
                let allName = []
                res.data.data.forEach(element => {
                    allName.push({
                        label: element,
                        value: element
                    })
                });
                setDivisionOption((prev) => [
                    ...new Set([...allName])
                ]);
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }

    }

    const getScoreDistribution = async (businessUnit, projectID) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get(`/auth/projects/score-distribution?businessUnit=${businessUnit}&projectID=${projectID}`)
            if (res.status === 200) {
                setScoreDistribution(res.data.data)
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }

    }

    const getRatingQuota = async (calibratorId, prevCalibrator, businessUnit, types, projectID, countCurrentUser) => {
        try {
            setLoadingPage(true)
            let countUser = countCurrentUser;
            if (!countCurrentUser) {
                countUser = 0
            }
            const projectPhaseOrder = new URLSearchParams(location.search).get("projectPhaseOrder")
            const projectPhaseOrderParam = projectPhaseOrder ? `&projectPhaseOrder=${encodeURIComponent(projectPhaseOrder)}` : ""
            let res = await axiosInstance.get(`/auth/projects/rating-quota?calibratorID=${calibratorId}&prevCalibrator=${prevCalibrator}&businessUnit=${businessUnit}&type=${types}&countCurrentUser=${countUser}&projectID=${projectID}${projectPhaseOrderParam}`)
            if (res.status === 200) {
                setRatingQuota({ ...res.data.data, Latest: "" })
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const getTotalActualScore = async (calibratorId, prevCalibrator, businessUnit, types, projectID) => {
        try {
            setLoadingPage(true)
            const projectPhaseOrder = new URLSearchParams(location.search).get("projectPhaseOrder")
            const projectPhaseOrderParam = projectPhaseOrder ? `&projectPhaseOrder=${encodeURIComponent(projectPhaseOrder)}` : ""
            let res = await axiosInstance.get(`/auth/projects/total-actual-score?calibratorID=${calibratorId}&prevCalibrator=${prevCalibrator}&businessUnit=${businessUnit}&type=${types}&projectID=${projectID}${projectPhaseOrderParam}`)
            if (res.status === 200) {
                setActualScore(res.data.data)

                setFilteredActualScore(res.data.data)
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const getTotalCalibratedScore = async (calibratorId, prevCalibrator = "", businessUnit, types, projectID) => {
        try {
            const projectPhaseOrder = new URLSearchParams(location.search).get("projectPhaseOrder")
            const projectPhaseOrderParam = projectPhaseOrder ? `&projectPhaseOrder=${encodeURIComponent(projectPhaseOrder)}` : ""
            let res = await axiosInstance.get(`/auth/projects/total-calibrated?calibratorID=${calibratorId}&prevCalibrator=${prevCalibrator}&businessUnit=${businessUnit}&type=${types}&projectID=${projectID}${projectPhaseOrderParam}`)
            if (res.status === 200) {
                setCountCalibrated(res.data.data)
                setFilteredCountCalibrated(res.data.data)
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const getAverageScore = async (calibratorId, prevCalibrator = "", businessUnit, types, projectID) => {
        try {
            setLoadingPage(true)
            const projectPhaseOrder = new URLSearchParams(location.search).get("projectPhaseOrder")
            const projectPhaseOrderParam = projectPhaseOrder ? `&projectPhaseOrder=${encodeURIComponent(projectPhaseOrder)}` : ""
            let res = await axiosInstance.get(`/auth/projects/average-score?calibratorID=${calibratorId}&prevCalibrator=${prevCalibrator}&businessUnit=${businessUnit}&type=${types}&projectID=${projectID}${projectPhaseOrderParam}`)
            if (res.status === 200) {
                setAverage(res.data.data)
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const getManagerPhase = async () => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get(`/auth/projects/project-phase/manager`)
            if (res.status === 200) {
                setManagerDeadline(res.data.data.EndDate)
                const date = new Date(res.data.data.EndDate);
                date.setHours(0, 0, 0, 0);
                const today = new Date()
                today.setHours(0, 0, 0, 0);

                if (today >= date) {
                    // setCanSubmit((prevState) => (prevState || true))   
                }
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const getProjectPhase = async (calibratorId, projectID) => {
        try {
            setLoadingPage(true)
            const projectPhaseOrder = new URLSearchParams(location.search).get("projectPhaseOrder")
            const projectPhaseOrderParam = projectPhaseOrder ? `&projectPhaseOrder=${encodeURIComponent(projectPhaseOrder)}` : ""
            let res = await axiosInstance.get(`/auth/projects/project-phase/calibrator?projectID=${projectID}&calibratorID=${calibratorId}${projectPhaseOrderParam}`)
            if (res.status === 200) {
                setProjectPhase(res.data.data)
                let data = []
                let phaseValue = -2
                for (let index = res.data.data.Phase.Order - 1; index > 0; index--) {
                    data.push({ 'label': index, 'value': phaseValue })
                    phaseValue -= 1
                }
                setPhaseOption(data)

                // let phaseStartDate = new Date(res.data.data.StartDate)
                // let startYear = phaseStartDate.getFullYear()
                // let startMonth = phaseStartDate.getMonth() + 1
                // let startDay = phaseStartDate.getDate()

                // let todayDate = new Date()
                // let todayYear = todayDate.getFullYear()
                // let todayMonth = todayDate.getMonth() + 1
                // let todayDay = todayDate.getDate()

                // if (todayYear >= startYear) {
                //     if (todayYear === startYear && todayMonth >= startMonth) {
                //         if (todayMonth === startMonth && todayDay >= startDay) {
                //             setWaitForPreviousCalibration(waitForPreviousCalibration || false)
                //         } else if(todayMonth > startMonth){
                //             setWaitForPreviousCalibration(waitForPreviousCalibration || false)
                //         }
                //     }else if(todayYear > startYear){
                //         setWaitForPreviousCalibration(waitForPreviousCalibration || false)
                //     }
                // }else{
                //     setWaitForPreviousCalibration(waitForPreviousCalibration || true)
                // }

                // 23 10 23
                // 23 11 08
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const getProjectDetails = async (projectID) => {
        try {
            let res = await axiosInstance.get(`/auth/projects/${projectID}`)
            if (res.status === 200) {
                setProject(res.data.data)
            }
        } catch (error) {
            if (error.response) {
                // Handle error response
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const getProjectRemark = async (projectID) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get(`/auth/remark-settings/${projectID}`)
            if (res.status === 200) {
                // Set the project remarks from the dedicated remark-settings endpoint
                setProjectRemark(res.data.data)
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                setProjectRemark([])
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const postChangeRatingScore = async (payload, calibratorID, params) => {
        try {
            let res = await axiosInstance.post(`/auth/calibrations/change-score-and-rating`, payload)
            if (res.status === 200) {
                if (calibratorID && params) {
                    getTotalCalibratedScore(calibratorID, params?.prev_calibrator || "", params.bu_performance, params.type, params.project_id)
                }
            }
            setLoadingPage(false)
            return res  // Return the actual response instead of true
        } catch (error) {
            if (error.response) {
                setProjectRemark([])
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
            return null  // Return null on error instead of undefined
        }

    }

    const checkTopBottomRemark = (before, after) => {
        let value = "default"

        // Safety check: return default if projectRemark is not available
        if (!projectRemark || !Array.isArray(projectRemark) || projectRemark.length === 0) {
            return value;
        }

        // First check for maximum level violations
        for (const data of projectRemark) {
            if (data.JustificationType === "maximum") {
                if (projectPhase.ID && data.From.split(";").includes(projectPhase.ID)) {
                    if (data.ScoringType === "level") {
                        if (Math.abs(ratingState[after] - ratingState[before]) > data.Level) {
                            value = "maximum"
                            return value // Return immediately if maximum is exceeded
                        }
                    }
                }
            }
        }

        // If not maximum violation, check for other justification types
        for (const data of projectRemark) {
            if (data.JustificationType === "top") {
                if (data.ScoringType === "level") {
                    if (ratingState[after] - ratingState[before] === data.Level) {
                        value = "top"
                        break
                    }
                } else {
                    if (before === data.From && after === data.To) {
                        value = "top"
                        break
                    }
                }
            } else if (data.JustificationType === "bottom") {
                if (data.ScoringType === "level") {
                    if (Math.abs(ratingState[after] - ratingState[before]) === data.Level) {
                        value = "bottom"
                        break
                    }
                } else {
                    if (before === data.From && after === data.To) {
                        value = "bottom"
                        break
                    }
                }
            } else if (data.JustificationType === "both") {
                if (data.ScoringType === "level") {
                    if (ratingState[after] - ratingState[before] === data.Level) {
                        value = "top"
                        break
                    } else if (Math.abs(ratingState[after] - ratingState[before]) === data.Level) {
                        value = "bottom"
                        break
                    }
                }
            }
        }

        return value
    }

    const onSaveCalibrations = async () => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.post(`/auth/calibrations/save-calibrations`, {
                RequestData: calibratedScore
            })
            if (res.status === 200) {
                toast.success("Success Save Calibrations")
                // setTimeout(() => {
                //     window.location.reload()
                // }, 1000)
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const checkAllCalibratedNotExcessRatingQuota = () => {
        let val = true
        if (!project["APlusExcess"]) {
            if (countCalibrated["APlus"] > ratingQuota["APlus"]) {
                val = false
            }
        }

        if (!project["AExcess"]) {
            if (countCalibrated["A"] > ratingQuota["A"]) {
                val = false
            }
        }

        if (!project["BPlusExcess"]) {
            if (countCalibrated["BPlus"] > ratingQuota["BPlus"]) {
                val = false
            }
        }

        if (!project["BExcess"]) {
            if (countCalibrated["B"] > ratingQuota["B"]) {
                val = false
            }
        }

        if (!project["CExcess"]) {
            if (countCalibrated["C"] > ratingQuota["C"]) {
                val = false
            }
        }

        if (!project["DExcess"]) {
            if (countCalibrated["D"] > ratingQuota["D"]) {
                val = false
            }
        }

        if (!val) {
            toast.error("There are calibration score that exceeds the guidance.")
        }
        return val
    }

    const checkCalibrateNotExceeds2Level = () => {
        let val = true
        for (const [key, value] of Object.entries(calibratedScore)) {
            if (Math.abs(ratingState[value.CalibrationRating] - ratingState[value.ActualRating]) > 2) {
                setJustificationNotFilled(prevState => [...prevState, key])
                // set to false if want to on the 2 level
                val = true
            }
        }
        if (!val) {
            toast.error("Maximum rating change's is 2 level upper or below the actual rating")
            let allData = [...calibratedUsers]
            const falseGroup = allData.filter(item => Math.abs(ratingState[calibratedScore[item.ID]?.CalibrationRating] - ratingState[calibratedScore[item.ID]?.ActualRating]) > 2);
            const trueGroup = allData.filter(item => Math.abs(ratingState[calibratedScore[item.ID]?.CalibrationRating] - ratingState[calibratedScore[item.ID]?.ActualRating]) <= 2);
            allData = [...falseGroup, ...trueGroup];
            setCalibratedUsers(allData);
            setTotalTopUser(falseGroup.length)
        }

        return val
    }

    const filledRemark = () => {
        let isValue = true
        let data = { ...calibratedScore }
        for (const [key, value] of Object.entries(data)) {
            if (value.FilledTopBottomMark === false) {
                setJustificationNotFilled(prevState => [...prevState, key])
                isValue = false
            }
        }

        if (!isValue) {
            toast.error("You should fill justification remark on top/bottom remark.")
            let allData = [...calibratedUsers]
            const falseGroup = allData.filter(item => calibratedScore[item.ID]?.FilledTopBottomMark === false);
            const trueGroup = allData.filter(item => calibratedScore[item.ID]?.FilledTopBottomMark === true);
            allData = [...falseGroup, ...trueGroup];
            setCalibratedUsers(allData);
            setTotalTopUser(falseGroup.length)
        }

        return isValue
    }

    const updateJustificationOnUser = () => {
        let data = { ...calibratedScore }
        for (const [key, value] of Object.entries(data)) {
            value.JustificationType = checkTopBottomRemark(value.ActualRating, value.CalibrationRating)
            let userCalibration = calibratedUsers.filter(obj => obj.ID === key)

            if (
                userCalibration[0].CalibrationScores[userCalibration[0].CalibrationScores.length - 1].BottomRemark.EmployeeID !== "" ||
                userCalibration[0].CalibrationScores[userCalibration[0].CalibrationScores.length - 1].TopRemarks.length !== 0 ||
                value.JustificationType === "default"
            ) {
                value.FilledTopBottomMark = true
            } else {
                value.FilledTopBottomMark = false
            }
        }

        setCalibratedScore(data)

        // Automatically sort users without justification to the top
        sortUsersByJustificationStatus()
    }

    const sortUsersByJustificationStatus = () => {
        let allData = [...calibratedUsers]
        const falseGroup = allData.filter(item => calibratedScore[item.ID]?.FilledTopBottomMark === false);
        const trueGroup = allData.filter(item => calibratedScore[item.ID]?.FilledTopBottomMark === true);

        if (falseGroup.length > 0) {
            allData = [...falseGroup, ...trueGroup];
            setCalibratedUsers(allData);
            setTotalTopUser(falseGroup.length)
        }
    }

    // Simplified function for submission pages - fetch ALL users and sort by justification
    const sortUsersByJustificationStatusForSubmission = async (calibratorId, prevCalibrator, businessUnit, type, rating, projectID) => {
        try {
            // Check if this is a submission page (has prevCalibrator OR type is "all")
            if (!prevCalibrator && type !== "all") {
                // This is individual BU page, use normal sorting
                sortUsersByJustificationStatus();
                return;
            }

            setLoadingPage(true);

            // Fetch ALL users without pagination for submission pages
            const resolvedProjectPhaseOrder = new URLSearchParams(location.search).get("projectPhaseOrder")
            let api;
            if (businessUnit && businessUnit !== "all") {
                // Single BU - fetch all users
                // api = `/auth/projects/calibrations?calibratorID=${calibratorId}&businessUnit=${businessUnit}&prevCalibrator=${prevCalibrator || ""}&projectID=${projectID}&page=1&limit=101`; // Large limit to get all
                api = '';
            } else {
                // Multiple BUs
                const projectPhaseOrderParam = resolvedProjectPhaseOrder ? `&projectPhaseOrder=${encodeURIComponent(resolvedProjectPhaseOrder)}` : ""
                api = `/auth/projects/calibrations-all-bu?calibratorID=${calibratorId}&businessUnit=${businessUnit}&projectID=${projectID}&page=1&limit=101${projectPhaseOrderParam}`;
            }

            if (rating) {
                if (prevCalibrator && prevCalibrator !== "N-1") {
                    api = `/auth/projects/calibrations-score?calibratorID=${encodeURIComponent(calibratorId)}&businessUnit=${businessUnit}&prevCalibrator=${prevCalibrator}&projectID=${projectID}&rating=${encodeURIComponent(rating)}&page=1&limit=101`;
                } else {
                    if (businessUnit && businessUnit !== "all") {
                        api = `/auth/projects/calibrations-score-all-bu?calibratorID=${encodeURIComponent(calibratorId)}&businessUnit=${businessUnit}&projectID=${projectID}&rating=${encodeURIComponent(rating)}&page=1&limit=101`;
                    } else {
                        api = `/auth/projects/calibrations-score-all?calibratorID=${encodeURIComponent(calibratorId)}&projectID=${projectID}&rating=${encodeURIComponent(rating)}&page=1&limit=101`;
                    }
                }
            }

            const res = await axiosInstance.get(api);

            if (res.status === 200 && res.data.data && res.data.data[0] && res.data.data[0].UserData) {
                const allUsers = res.data.data[0].UserData;

                // Process all users to determine justification status
                let calibratedScores = {};
                let usersNeedingJustification = [];
                let usersWithJustification = [];

                allUsers.forEach(user => {
                    let userCalScorelength = user.CalibrationScores.length;
                    let latestCalibration = user.CalibrationScores[userCalScorelength - 1];

                    // Build calibratedScore object for this user
                    calibratedScores[user.ID] = {
                        ScoringMethod: user.ScoringMethod,
                        ProjectID: latestCalibration.ProjectID,
                        CalibratorID: latestCalibration.CalibratorID,
                        EmployeeID: user.ID,
                        ProjectPhaseID: latestCalibration.ProjectPhaseID,
                        CalibrationRating: latestCalibration.CalibrationRating,
                        CalibrationRatingBefore: latestCalibration.CalibrationRating,
                        CurrentSavedRating: latestCalibration.CalibrationRating,
                        CalibrationScore: latestCalibration.CalibrationScore,
                        JustificationType: latestCalibration.JustificationType,
                        FilledTopBottomMark: latestCalibration.FilledTopBottomMark,
                        SpmoID: latestCalibration.SpmoID,
                        Status: latestCalibration.Status,
                        SpmoStatus: latestCalibration.SpmoStatus,
                        Comment: latestCalibration.Comment,
                        CalibrationRatingSaved: latestCalibration.CalibrationRating,
                        CalibrationScoreSaved: latestCalibration.CalibrationScore,
                        ActualScore: user.ActualScores[0].ActualScore,
                        ActualRating: user.ActualScores[0].ActualRating,
                    };

                    // Check justification status
                    const actualRating = user.ActualScores[0].ActualRating;
                    const justificationType = checkTopBottomRemark(actualRating, latestCalibration.CalibrationRating);

                    const needsJustification = justificationType !== "default" &&
                        latestCalibration.BottomRemark.EmployeeID === "" &&
                        latestCalibration.TopRemarks.length === 0;

                    // Update the justification status in calibratedScores
                    calibratedScores[user.ID].JustificationType = justificationType;
                    calibratedScores[user.ID].FilledTopBottomMark = !needsJustification;

                    // Sort users into groups
                    if (needsJustification) {
                        usersNeedingJustification.push(user);
                    } else {
                        usersWithJustification.push(user);
                    }
                });

                // Combine users with those needing justification first
                // const sortedUsers = [...usersNeedingJustification, ...usersWithJustification];

                // Update state with all users and proper sorting
                // setCalibratedUsers(sortedUsers);
                // setCalibratedScore(calibratedScores);
                // setTotalTopUser(usersNeedingJustification.length);
                setCalibratedUsers([]);
                setCalibratedScore([]);
                setTotalTopUser(0);

                // Set page to 1 to show the sorted results
                if (setPage && page !== 1) {
                    setPage(1);
                }
            } else {
                sortUsersByJustificationStatus();
            }

            setLoadingPage(false);

        } catch (error) {
            console.error("Error in simplified justification sorting:", error);
            setLoadingPage(false);
            // Fallback to normal sorting
            sortUsersByJustificationStatus();
        }
    }

    const checkAllConditionThisPage = () => {
        var flag = true
        if (filledRemark() && checkCalibrateNotExceeds2Level()) {
            if (projectPhase.Guideline) {
                if (checkAllCalibratedNotExcessRatingQuota()) {
                    flag = true
                } else {
                    flag = false
                }
            }
        } else {
            flag = false
        }

        return flag
    }

    const onSubmitCalibrations = async (id, projectID, buID) => {
        try {
            var flag = true
            if (filledRemark() && checkCalibrateNotExceeds2Level()) {
                if (projectPhase.Guideline) {
                    if (checkAllCalibratedNotExcessRatingQuota()) {
                        flag = true
                    } else {
                        flag = false
                    }
                }
            } else {
                flag = false
            }

            if (flag) {
                setLoadingPage(true)
                const projectPhaseOrder = new URLSearchParams(location.search).get("projectPhaseOrder")
                const projectPhaseOrderParam = projectPhaseOrder ? `?projectPhaseOrder=${encodeURIComponent(projectPhaseOrder)}` : ""
                let res = await axiosInstance.post(`/auth/calibrations/submit-calibrations/${id}/${projectID}/${buID}${projectPhaseOrderParam}`, {
                    RequestData: calibratedScore
                })
                if (res.status === 200) {
                    toast.success("Success Submit Calibrations")
                    navigate(location.pathname + "/1")
                    setTimeout(() => {
                        window.location.reload()
                    }, 1000)
                }
                setLoadingPage(false)
            }
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const onSendCalibrationsToManager = async (id, projectID, businessUnit, prevCalibrator) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.post(`/auth/calibrations/send-calibration-to-manager?calibratorID=${id}&projectID=${projectID}&businessUnit=${businessUnit}&prevCalibrator=${prevCalibrator}`)
            if (res.status === 200) {
                toast.success("Success Send Calibrations To Manager")
                navigate(location.pathname + "/1")
                setTimeout(() => {
                    window.location.reload()
                }, 1000)
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const onSendBackCalibrations = async (id, projectID, businessUnit, prevCalibrator) => {
        try {
            setLoadingPage(true)
            const projectPhaseOrder = new URLSearchParams(location.search).get("projectPhaseOrder")
            const projectPhaseOrderParam = projectPhaseOrder ? `&projectPhaseOrder=${encodeURIComponent(projectPhaseOrder)}` : ""
            let res = await axiosInstance.post(`/auth/calibrations/send-calibrations-back?calibratorID=${id}&projectID=${projectID}&businessUnit=${businessUnit}&prevCalibrator=${prevCalibrator}${projectPhaseOrderParam}`)
            if (res.status === 200) {
                toast.success("Success Send Back Calibrations")
                navigate(location.pathname + "/1")
                setTimeout(() => {
                    window.location.reload()
                }, 1000)
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const getAllData = (user, params) => {
        if (user.ID) {
            getProjectPhase(user.ID, params.project_id) //ga error
            if (params) {
                setParamsData(params)
                setCurrentUser(user)
                getUserCurrentProject(user.ID, params.prev_calibrator || "", params.bu_performance, params.type, params.rating, params.project_id, page,
                    [], [], [], [], "default", "default", "default", "default", "default", "default", "",
                    -1, "default", "default", "", "all") //ga error
                if (params.type) {
                    getRatingQuota(user.ID, params.prev_calibrator || "", params.bu_performance, params.type, params.project_id, 0) // ga error
                    getTotalActualScore(user.ID, params.prev_calibrator || "", params.bu_performance, params.type, params.project_id) // ga error
                    getTotalCalibratedScore(user.ID, params.prev_calibrator || "", params.bu_performance, params.type, params.project_id) // ga error
                    getAverageScore(user.ID, params.prev_calibrator || "", params.bu_performance, params.type, params.project_id)
                    getAllEmployeeName(user.ID, params.prev_calibrator || "", params.bu_performance, params.type, params.project_id)
                    getAllSupervisorName(user.ID, params.prev_calibrator || "", params.bu_performance, params.type, params.project_id)
                    getAllGrade(user.ID, params.prev_calibrator || "", params.bu_performance, params.type, params.project_id)
                    getAllDivision(user.ID, params.prev_calibrator || "", params.bu_performance, params.type, params.project_id)
                }
                getScoreDistribution(params.bu_performance, params.project_id)
            }
            getManagerPhase()
        }
    }

    const updateTable = async (
        calibratedUsers,
        sortScoreLatest,
        sortRatingLatest,
        filterRating,
        sortScoreLatestMinusOne,
        sortRatingLatestMinusOne,
        filterRatingBefore,
        sortName,
        customOrder,
        latestCalibration,
        setFilteredUser,
        sortGrade,
        filterUserName,
        filterGrade,
        filterSupervisorName,
        filterChangeScore,
        totalUser = totalTopUser
    ) => {
        let sortedList = [...calibratedUsers]

        // Sort User Based on Calibration Score Latest
        let keepUser = sortedList.slice(0, totalUser)
        let sortedUser = sortedList.slice(totalUser)

        // sortedUser = sortedUser.sort((a,b) => customOrder[b.CalibrationScores[b.CalibrationScores.length-1].CalibrationRating] - customOrder[a.CalibrationScores[a.CalibrationScores.length-1].CalibrationRating]
        //             || b.CalibrationScores[b.CalibrationScores.length-1].CalibrationScore - a.CalibrationScores[a.CalibrationScores.length-1].CalibrationScore
        //             || b.ActualScores[0].ActualScore - a.ActualScores[0].ActualScore)
        keepUser = keepUser.sort((a, b) => customOrder[b.CalibrationScores[b.CalibrationScores.length - 1].CalibrationRating] - customOrder[a.CalibrationScores[a.CalibrationScores.length - 1].CalibrationRating]
            || b.CalibrationScores[b.CalibrationScores.length - 1].CalibrationScore - a.CalibrationScores[a.CalibrationScores.length - 1].CalibrationScore
            || b.ActualScores[0].ActualScore - a.ActualScores[0].ActualScore)
        sortedList = keepUser.concat(sortedUser)

        // if (sortScoreLatest === "ascending") {
        //     sortedList = sortedList.sort((a, b) => calibratedScore[a.ID].CalibrationScore - calibratedScore[b.ID].CalibrationScore)
        // } else if(sortScoreLatest === "descending") {
        //     sortedList = sortedList.sort((a, b) => calibratedScore[b.ID].CalibrationScore - calibratedScore[a.ID].CalibrationScore)
        // }

        // if (sortRatingLatest === "ascending") {
        //     sortedList = sortedList.sort((a, b) => customOrder[calibratedScore[a.ID].CalibrationRating] - customOrder[calibratedScore[b.ID].CalibrationRating]);
        // } else if(sortRatingLatest === "descending") {
        //     sortedList = sortedList.sort((a, b) => customOrder[calibratedScore[b.ID].CalibrationRating] - customOrder[calibratedScore[a.ID].CalibrationRating]);   
        // }

        // if (filterRating != 'None') {
        //     sortedList = sortedList.filter((data) => calibratedScore[data.ID].CalibrationRating === filterRating)
        // }

        // if (sortScoreLatestMinusOne === "ascending") {
        //     sortedList = sortedList.sort((a, b) => a.CalibrationScores[a.CalibrationScores.length + latestCalibration].CalibrationScore - b.CalibrationScores[b.CalibrationScores.length + latestCalibration].CalibrationScore)
        // } else if(sortScoreLatestMinusOne === "descending") {
        //     sortedList = sortedList.sort((a, b) => b.CalibrationScores[b.CalibrationScores.length + latestCalibration].CalibrationScore - a.CalibrationScores[a.CalibrationScores.length + latestCalibration].CalibrationScore)
        // }

        // if (sortRatingLatestMinusOne === "ascending") {
        //     sortedList = sortedList.sort((a, b) => customOrder[a.CalibrationScores[a.CalibrationScores.length + latestCalibration].CalibrationRating] - customOrder[b.CalibrationScores[b.CalibrationScores.length + latestCalibration].CalibrationRating]);
        // } else if(sortRatingLatestMinusOne === "descending") {
        //     sortedList = sortedList.sort((a, b) => customOrder[b.CalibrationScores[b.CalibrationScores.length + latestCalibration].CalibrationRating] - customOrder[a.CalibrationScores[a.CalibrationScores.length + latestCalibration].CalibrationRating]);   
        // }

        // if (filterRatingBefore != 'None') {
        //     sortedList = sortedList.filter((data) => data.CalibrationScores[data.CalibrationScores.length + latestCalibration].CalibrationRating === filterRatingBefore)
        // }

        // if (!sortedList) {
        //     setFilteredUser([])
        // }

        // if (sortName === "ascending") {
        //     sortedList = sortedList.sort(function (a, b) {
        //         if (a.Name < b.Name) {
        //           return -1;
        //         }
        //         if (a.Name > b.Name) {
        //           return 1;
        //         }
        //         return 0;
        //       })
        // } else if(sortName === "descending") {
        //     sortedList = sortedList.sort(function (a, b) {
        //         if (a.Name > b.Name) {
        //           return -1;
        //         }
        //         if (a.Name < b.Name) {
        //           return 1;
        //         }
        //         return 0;
        //       })
        // }

        // if (sortGrade === "ascending") {
        //     sortedList = sortedList.sort(function (a, b) {
        //         if (parseInt(a.Grade) < parseInt(b.Grade)) {
        //           return -1;
        //         }
        //         if (parseInt(a.Grade) > parseInt(b.Grade)) {
        //           return 1;
        //         }
        //         return 0;
        //       })
        // } else if(sortGrade === "descending") {
        //     sortedList = sortedList.sort(function (a, b) {
        //         if (parseInt(a.Grade) > parseInt(b.Grade)) {
        //           return -1;
        //         }
        //         if (parseInt(a.Grade) < parseInt(b.Grade)) {
        //           return 1;
        //         }
        //         return 0;
        //       })
        // }

        // if (filterUserName) {
        //     if (filterUserName.length > 0) {
        //         sortedList = sortedList.filter(user => filterUserName.includes(user.Name));
        //     }
        // }
        // if (filterGrade) {
        //     if (filterGrade.length > 0) {
        //         sortedList = sortedList.filter(user => filterGrade.includes(user.Grade));
        //     }
        // }
        // if (filterSupervisorName) {
        //     if (filterSupervisorName.length > 0) {
        //         sortedList = sortedList.filter(user => filterSupervisorName.includes(user.SupervisorNames));
        //     }
        // }


        // if(filterChangeScore === 'changed') {
        //     sortedList = sortedList.filter(user => {
        //         let userCalibration = calibratedUsers.filter(obj => obj.ID === user.ID)
        //         let calLength = userCalibration[0].CalibrationScores.length - 2

        //         let scoreBefore = 0
        //         let ratingBefore = ""
        //         while (calLength >= 0) {
        //             scoreBefore = userCalibration[0].CalibrationScores[calLength].CalibrationScore
        //             ratingBefore = userCalibration[0].CalibrationScores[calLength].CalibrationRating
        //             calLength--;
        //             if (scoreBefore && ratingBefore) {
        //                 break
        //             }
        //         }
        //         if (!scoreBefore && !ratingBefore) {
        //             scoreBefore = userCalibration[0].ActualScores[0].ActualScore
        //             ratingBefore = userCalibration[0].ActualScores[0].ActualRating
        //         }

        //         if (calibratedScore[user.ID].CalibrationScore != scoreBefore || calibratedScore[user.ID].CalibrationRating != ratingBefore) {
        //             return true
        //         }
        //         return false
        //     })
        // } else if(filterChangeScore === 'unchanged') {
        //     sortedList = sortedList.filter(user => {
        //         let userCalibration = calibratedUsers.filter(obj => obj.ID === user.ID)
        //         let calLength = userCalibration[0].CalibrationScores.length - 2

        //         let scoreBefore = 0
        //         let ratingBefore = ""
        //         while (calLength >= 0) {
        //             scoreBefore = userCalibration[0].CalibrationScores[calLength].CalibrationScore
        //             ratingBefore = userCalibration[0].CalibrationScores[calLength].CalibrationRating
        //             calLength--;
        //             if (scoreBefore && ratingBefore) {
        //                 break
        //             }
        //         }
        //         if (!scoreBefore && !ratingBefore) {
        //             scoreBefore = userCalibration[0].ActualScores[0].ActualScore
        //             ratingBefore = userCalibration[0].ActualScores[0].ActualRating
        //         }

        //         if ((userCalibration[0].ScoringMethod === "Rating" && calibratedScore[user.ID].CalibrationRating === ratingBefore)
        //         ||(userCalibration[0].ScoringMethod === "Score" && calibratedScore[user.ID].CalibratioScore === scoreBefore)) {
        //             return true
        //         }
        //         return false
        //     })
        // } else if((filterChangeScore>= 1 && filterChangeScore <= 4) || (filterChangeScore>= -4 && filterChangeScore <= -1)){
        //     let dataFilterChangeScore = filterChangeScore
        //     sortedList = sortedList.filter(user => {
        //         let userCalibration = calibratedUsers.filter(obj => obj.ID === user.ID)
        //         let calLength = userCalibration[0].CalibrationScores.length - 2

        //         let scoreBefore = 0
        //         let ratingBefore = ""
        //         while (calLength >= 0) {
        //             scoreBefore = userCalibration[0].CalibrationScores[calLength].CalibrationScore
        //             ratingBefore = userCalibration[0].CalibrationScores[calLength].CalibrationRating
        //             calLength--;
        //             if (scoreBefore && ratingBefore) {
        //                 break
        //             }
        //         }
        //         if (!scoreBefore && !ratingBefore) {
        //             scoreBefore = userCalibration[0].ActualScores[0].ActualScore
        //             ratingBefore = userCalibration[0].ActualScores[0].ActualRating
        //         }

        //         let ratingNow = calibratedScore[user.ID].CalibrationRating
        //         let difference = ratingState[ratingNow] - ratingState[ratingBefore]

        //         if (difference === dataFilterChangeScore) {
        //             return true
        //         } 
        //         return false
        //     })

        // }

        // if (currentUser && paramsData) {
        //     getRatingQuota(currentUser?.ID, paramsData?.prev_calibrator, paramsData?.bu_performance, paramsData?.type, paramsData?.project_id)
        // }
        setFilteredUser(sortedList)
        // countActualScoreAfterFilter(sortedList)
        // countCountedScoreAfterFilter(sortedList)
    }

    // const countActualScoreAfterFilter = async (sortedList) => {
    //     let finalData = {
    //         APlus: 0,
    //         A: 0,
    //         BPlus: 0,
    //         B: 0,
    //         C: 0,
    //         D: 0,
    //         Total: 0
    //     }
    //     sortedList.forEach(element => {
    //         if (element.ActualScores[0].ActualRating === "A+") {
    //             finalData.APlus += 1
    //         } else if (element.ActualScores[0].ActualRating === "A") {
    //             finalData.A += 1
    //         } else if (element.ActualScores[0].ActualRating === "B+") {
    //             finalData.BPlus += 1
    //         } else if (element.ActualScores[0].ActualRating === "B") {
    //             finalData.B += 1
    //         } else if (element.ActualScores[0].ActualRating === "C") {
    //             finalData.C += 1
    //         } else {
    //             finalData.D += 1
    //         }
    //         finalData.Total += 1
    //     });

    //     setFilteredActualScore(finalData)
    // }

    // const countCountedScoreAfterFilter = async (sortedList) => {
    //     let finalData = {
    //         APlus: 0,
    //         A: 0,
    //         BPlus: 0,
    //         B: 0,
    //         C: 0,
    //         D: 0,
    //         Total: 0
    //     }
    //     sortedList.forEach(element => {
    //         if (calibratedScore[element.ID].CalibrationRating === "A+") {
    //             finalData.APlus += 1
    //         } else if (calibratedScore[element.ID].CalibrationRating === "A") {
    //             finalData.A += 1
    //         } else if (calibratedScore[element.ID].CalibrationRating === "B+") {
    //             finalData.BPlus += 1
    //         } else if (calibratedScore[element.ID].CalibrationRating === "B") {
    //             finalData.B += 1
    //         } else if (calibratedScore[element.ID].CalibrationRating === "C") {
    //             finalData.C += 1
    //         } else {
    //             finalData.D += 1
    //         }
    //         finalData.Total += 1
    //     });

    //     setFilteredCountCalibrated(finalData)
    // }


    const downloadReportFileExcel = (calibratorId, prevCalibrator, businessUnit, type, projectID) => {
        return `/auth/projects-report/${type}/${calibratorId}/${businessUnit}/${prevCalibrator}/${projectID}`
    }

    const getBusinessPerformance = async (projectId, businessUnitID) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get(`/auth/rating-quotas/${projectId}/${businessUnitID}`)
            if (res.status === 200) {
                setBusinessPerformance({ ...res.data.data })
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    return {
        automaticallyChangeRating,
        onChangeHandler,
        calibratedUsers,
        calibratedScore,
        countCalibrated,
        ratingQuota,
        actualScore,
        scoreDistribution,
        deviationRating,
        setDeviationRating,
        projectPhase,
        getProjectDetails,
        getProjectRemark,
        projectRemark,
        show,
        handleClose,
        handleShow,
        setCalibratedScore,
        onSaveCalibrations,
        onSubmitCalibrations,
        onSendCalibrationsToManager,
        onSendBackCalibrations,
        project,
        checkAllCalibratedNotExcessRatingQuota,
        updateJustificationOnUser,
        sortUsersByJustificationStatus,
        sortUsersByJustificationStatusForSubmission,
        averageAllScore,
        justificationIdNotFilled,
        canSubmit,
        phaseOption,
        waitForPreviousCalibration,
        alreadySendToManager,
        canSendToManager,
        sendBackCalibrations,
        managerDeadline,
        getAllData,
        loadingPagestate,
        totalTopUser,
        updateTable,
        downloadReportFileExcel,
        getBusinessPerformance,
        businessPerformance,
        userNameOption,
        gradeOption,
        supervisorNameOption,
        divisionOption,
        filteredActualScore,
        filteredCountCalibrated,
        page,
        totalPage,
        changePage,
        setPage,
        getUserCurrentProject,
        postChangeRatingScore,
        getTotalCalibratedScore,
        getAverageScore,
        ratingState,
        checkTopBottomRemark,
        filledRemark,
    }
}
export default useDetailCurrentProject